<template>
  <div class="box"> 
   
    <div class="newsviews">
         <img class="ttouimg" src="/static/img/img_zhuanjiabnner.png" alt="" />
      <div class="tab">
        专家智库
      </div>
      <div class="classfy">
        <!-- 从业方向 -->
        <ul>
            <li @click="getNewsViews();activeInfoIndex=-1" >
                <div class="cytype" :class="{ active: activeInfoIndex === -1}">
                    <span>所有专家</span>
                </div>
            </li>
             <li v-for="(item,index) in CategoryChilds.slice(0,7)" :key="index" @click="getZhuanjOfType(item);activeInfoIndex=index">
                <div class="cytype" :class="{ active: activeInfoIndex === index}">
                    <span>{{item.name}}</span>
                </div>
            </li>
             <li v-if="CategoryChilds.length > 7" @click="activeInfoIndex=7;">
                <div class="cytype" :class="{ active: activeInfoIndex === 7}">
                    <el-dropdown @command="getZhuanjOfType" size="medium">
                        <span class="el-dropdown-link">
                            更多行业<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="(item,index) in CategoryChilds.slice(7)" :key="index" :command="item">{{item.name}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </li>
        </ul>
      </div>
      <div class="views">
        <ul>
            <li v-for="(zhuanj,index) in realList" :key="index" @click="$router.push(`/news/info/${zhuanj.plateid}/${zhuanj.uuid}`)">
                <div class="zhuanj">
                    <img :src="`${IP_TEST}/uploads/${zhuanj.picsrc}`" alt="">
                    <div class="zhuanjinfo" >
                      <h3>{{zhuanj.title}}<img src="/static/img/img_zhuanshi2.png" style="    width: 158px;height: 8px;margin-left: 19px;margin-top: 5px;" /></h3>
                      <p class="keyword">{{zhuanj.keywords}}</p>
                      <p class="descrip">{{zhuanj.description}}</p>
                    </div>
                </div>
            </li>
        </ul>
      </div>
      <ul class="pages" v-if="sumPages">
        <el-pagination
            background
            :hide-on-single-page="true"
            layout="prev, pager, next"
            :page-size='6'
            @current-change="toPage"
            @prev-click="toPage"
            @next-click="toPage"
            :total="totalCount">
        </el-pagination>
      </ul>
    </div>
  </div>
</template>

<script>
import { IP_TEST } from '@/config'
import { getNewsViews, getSearch,getCategoryInfo,getChildNewsViews } from '@/request/get'
export default {
  name: "NewsViews",
  components: {
  },
  data() {
    return {
      plateId: this.$route.params.plateId||'',
      current: 1,
      list: [],
      realList: [],
      pageNum: 6,//每页条数
      sumPages: 0,//总页数
      pageIndex: 1,//当前页
      showPageNums:[1,2,3,4],//页码
      CategoryChilds:[],
      activeInfoIndex:-1,
      selType:'',
      totalCount: 0,
      IP_TEST: IP_TEST
    }
  },
  filters: {
    filterdate(date) {
      return date.slice(0, 10).replace("-", "年").replace("-", "月")+"日";
    },
    filterPage(page) {
      if (page === 0) {
        return ""
      }
      return page
    }
  },
  computed: {
    title() {
      let { plates } = this.$store.state;
      if (this.plateId == "search") {
        return "搜索结果"
      }
      let arrs = plates.filter(item => item.uuid == this.plateId)
      return arrs.length === 0 ? "未配置" : arrs[0].name
    }
  },
  created() {
      this.getNewsViews();
      this.getCategoryInfo();
  },
  mounted() {
    this.toTop();
  },
  methods: {
    toPage(current){
        this.current = current;
        if(this.activeInfoIndex>-1)
        {
            this.getZhuanjOfType(this.selType);
        }else{
            this.getNewsViews();
        }
    },
    async getSearch() {
      let result = await getSearch(this.$route.query.keyWords);
      result = result.data;
      this.list = result || [];
      this.sumPages = Math.ceil(result.length / this.pageNum);
      this.handlePage(1);
    },
    async getCategoryInfo(){
        let result = await getCategoryInfo(this.plateId);
        result = result.data.CategoryChildren;
        this.CategoryChilds = result|| [];
    },
    async getNewsViews() {
      let result = await getNewsViews(this.plateId, this.current,6);
      this.totalCount = result.count;
      result = result.data;
      this.list = result || [];
      this.sumPages = Math.ceil(result.length / this.pageNum);
      this.handlePage(1);
      
    },
    async getZhuanjOfType(type){
        this.selType = type;
        let result = await getChildNewsViews(this.plateId,type.uuid, this.current,6);
        this.totalCount = result.count;
        this.realList = result.data || [];
    },
    setShowPageNums() {
      let pageNum = this.pageNum;
      let pageIndex = this.pageIndex;
      if (pageIndex > pageNum) {
        this.showPageNums = [pageIndex-3, pageIndex-2, pageIndex-1, pageIndex];
      } else {
        this.showPageNums = [1, 2, 3, 4];
      } 
    },
    handlePage(pages) {
      let pageNum = this.pageNum;
      let sumPages = this.sumPages;
      pages = pages < 1 ? 1 : pages;
      pages = pages > sumPages ? sumPages : pages;
      this.pageIndex = pages;
      this.setShowPageNums();
      this.realList = this.list.filter((item, index) => {
        return pageNum * (pages - 1) <= index && index < pageNum * pages;
      })
    },
    upPage() {
      let pages = this.pageIndex - 1;
      this.handlePage(pages);
    },
    nextPage() {
      let pages = this.pageIndex + 1;
      this.handlePage(pages);
    },
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>
<style scoped>
.box{
  position: relative;
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
}
.newsviews{
  position: relative;
  width: 1300px;
  /* min-height: 1166px; */
  margin: 0 auto;
  overflow: hidden;
}
.newsviews .ttouimg{
    margin: 12px auto;
}
.newsviews>.pages{
  position: relative;
  margin-top:9px;
  width: 1300px;
  height: 34px;
  display: flex;
  justify-content: end;
}
.newsviews>.pages>li{
  margin-right: 23px;
  width: 34px;
  height: 34px;
  border: 1px solid #EDEDED;
  font-size: 14px;

  font-weight: 500;
  color: #999999;
  line-height: 34px;
  text-align: center;
}
.newsviews>.pages>li.up{
  background:url(/static/img/left.png) ;
  background-size: 34px 34px;
}
.newsviews>.pages>li.show{
  background: #306BCD;
  color: #FFFFFF;
}
.newsviews>.pages>li.next {
  background: url(/static/img/right.png);
  background-size: 34px 34px;
}
.newsviews .tab{
font-size: 28px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
margin-top: 38px;;
/* line-height: 155px; */
}
.newsviews .classfy{
    width: 100%;
    font-size: 16px;
  
    font-weight: 500;
    padding: 24px 0;
}
.newsviews .classfy ul{
    display: flex;
}
.newsviews .classfy ul li{
   flex: 1;
   -webkit-box-flex: 1;
}
.cytype{
width: 150px;
height: 34px;
background: #e1f3e7;
border-radius: 17px;
text-align: center;
line-height: 34px;
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
}
.cytype.active{
    width: 150px;
    height: 34px;
    background: #2b964e;
    border-radius: 17px;
    color: #FFFFFF;
}
.cytype.active .el-dropdown-link
{
    color: #FFFFFF;
}
.zhuanj{
    width: 576px;
    height: 243px;
    background-color: #F3F3F3;
     border-radius: 5px;
}
.zhuanj img{
    width: 180px;
    height: 243px;
    border-radius: 5px 0px 0px 5px;
}
.views ul
{
     display: flex;
     flex-flow:row wrap
}
.views ul li{
   display: inline-block;
    margin-right: 43px;
    margin-bottom: 43px;;
}
.views ul li:nth-child(2n){
  margin-right: 0px;
}
.zhuanjinfo{
    display: inline-block;
        width: 380px;
    padding-right:10px ;
}
.zhuanjinfo h3{
     font-size: 24px;
  
    font-weight: bold;
    color: #138839;
    margin-top: 32px;
    margin-left: 9px;
}
.zhuanjinfo .keyword{
 font-size: 16px;
  
    font-weight: 500;
    color: #138839;
    margin-left: 9px;
    margin-top: 19px;
    margin-bottom: 20px;
}
.zhuanjinfo .descrip{
font-size: 16px;
  
    font-weight: 500;
    color: #333;
    line-height: 28px;
    margin-left: 9px;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
</style>
